export default "__VITE_ASSET__BCuDOEqv__"